// extracted by mini-css-extract-plugin
module.exports = {"accordion":"C_M","active":"C_cs","icon":"C_bj"};